var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPinWhite = function SvgMapPinWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#map-pin-white_svg__a)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.633 9.089c0 5.64-7.251 10.474-7.251 10.474S3.13 14.73 3.13 9.09a7.252 7.252 0 1 1 14.503 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.382 11.505a2.417 2.417 0 1 0 0-4.834 2.417 2.417 0 0 0 0 4.834Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "map-pin-white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.382 .549)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMapPinWhite;